import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { STR_BUY_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWarning, MdWhatsapp } from "react-icons/md";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		//..
	}

	return (
		<div
			className="card"
		>
			<div className="card-body">
				
				<h6
					style={{
						fontSize: "22px",
					}}
					className="font-semi-bold text-secondary mb-1"
				>
					{JSON.parse(data.recepient)?.name}
				</h6>

				<div
				>
					{(data.status === 'success') ? <span className="badge bg-success">{data.status}</span> : ""}
					{(data.status === 'failed') ? <span className="badge bg-danger">{data.status}</span> : ""}
					{(data.status === 'pending') ? <span className="badge bg-dark">{data.status}</span> : ""}
					{(data.status === 'in-progress') ? <span className="badge bg-warning">{data.status}</span> : ""}
				</div>

				{
					(data.notes) ?
					<h6
						className="text-danger mt-4"
						style={{
							fontSize: "14px"
						}}
					>
						<MdWarning size={24}/> {data.notes}
					</h6>
					:""
				}

				<div className="mt-1 d-flex justify-content-end">

					<div className="d-flex m-1">
						<MdMessage className="align-self-center" size={24}/>
						<h6
							style={{
								fontSize: "12px",
							}}
							className="font-semi-bold align-self-center mNoMargin"
						>
							{JSON.parse(data.recepient)?.phoneNumber}
						</h6>

					</div>

					<div className="d-flex m-1">
						<MdWhatsapp className="align-self-center" size={24}/>
						<h6
							style={{
								fontSize: "12px",
							}}
							className="font-semi-bold align-self-center mNoMargin"
						>
							{JSON.parse(data.recepient)?.whatsAppNumber || "N/A"}
						</h6>
					</div>

				</div>

				
			</div>
		</div>
	);
}
